// VibeVox: канонический список языков (синхронизирован с apps/frontend/src/config/i18n.ts
// основного приложения). Используется пикером языка двустороннего переводчика в окне ответа.
// name = как пишут носители; en = английское имя (для поиска). target для Gemini = en.
export const VIBEVOX_LANGUAGES = [
  { code: 'af', name: 'Afrikaans', en: 'Afrikaans' },
  { code: 'sq', name: 'Shqip', en: 'Albanian' },
  { code: 'am', name: 'አማርኛ', en: 'Amharic' },
  { code: 'ar', name: 'العربية', en: 'Arabic' },
  { code: 'hy', name: 'Հայերեն', en: 'Armenian' },
  { code: 'az', name: 'Azərbaycan', en: 'Azerbaijani' },
  { code: 'eu', name: 'Euskara', en: 'Basque' },
  { code: 'be', name: 'Беларуская', en: 'Belarusian' },
  { code: 'bn', name: 'বাংলা', en: 'Bengali' },
  { code: 'bs', name: 'Bosanski', en: 'Bosnian' },
  { code: 'bg', name: 'Български', en: 'Bulgarian' },
  { code: 'ca', name: 'Català', en: 'Catalan' },
  { code: 'ceb', name: 'Cebuano', en: 'Cebuano' },
  { code: 'zh', name: '中文', en: 'Chinese' },
  { code: 'co', name: 'Corsu', en: 'Corsican' },
  { code: 'hr', name: 'Hrvatski', en: 'Croatian' },
  { code: 'cs', name: 'Čeština', en: 'Czech' },
  { code: 'da', name: 'Dansk', en: 'Danish' },
  { code: 'nl', name: 'Nederlands', en: 'Dutch' },
  { code: 'en', name: 'English', en: 'English' },
  { code: 'eo', name: 'Esperanto', en: 'Esperanto' },
  { code: 'et', name: 'Eesti', en: 'Estonian' },
  { code: 'fi', name: 'Suomi', en: 'Finnish' },
  { code: 'fr', name: 'Français', en: 'French' },
  { code: 'fy', name: 'Frysk', en: 'Frisian' },
  { code: 'gl', name: 'Galego', en: 'Galician' },
  { code: 'ka', name: 'ქართული', en: 'Georgian' },
  { code: 'de', name: 'Deutsch', en: 'German' },
  { code: 'el', name: 'Ελληνικά', en: 'Greek' },
  { code: 'gu', name: 'ગુજરાતી', en: 'Gujarati' },
  { code: 'ht', name: 'Kreyòl Ayisyen', en: 'Haitian Creole' },
  { code: 'ha', name: 'Hausa', en: 'Hausa' },
  { code: 'haw', name: 'ʻŌlelo Hawaiʻi', en: 'Hawaiian' },
  { code: 'he', name: 'עברית', en: 'Hebrew' },
  { code: 'hi', name: 'हिन्दी', en: 'Hindi' },
  { code: 'hmn', name: 'Hmoob', en: 'Hmong' },
  { code: 'hu', name: 'Magyar', en: 'Hungarian' },
  { code: 'is', name: 'Íslenska', en: 'Icelandic' },
  { code: 'ig', name: 'Igbo', en: 'Igbo' },
  { code: 'id', name: 'Bahasa Indonesia', en: 'Indonesian' },
  { code: 'ga', name: 'Gaeilge', en: 'Irish' },
  { code: 'it', name: 'Italiano', en: 'Italian' },
  { code: 'ja', name: '日本語', en: 'Japanese' },
  { code: 'jv', name: 'Basa Jawa', en: 'Javanese' },
  { code: 'kn', name: 'ಕನ್ನಡ', en: 'Kannada' },
  { code: 'kk', name: 'Қазақша', en: 'Kazakh' },
  { code: 'km', name: 'ខ្មែរ', en: 'Khmer' },
  { code: 'rw', name: 'Kinyarwanda', en: 'Kinyarwanda' },
  { code: 'ko', name: '한국어', en: 'Korean' },
  { code: 'ku', name: 'Kurdî', en: 'Kurdish' },
  { code: 'ky', name: 'Кыргызча', en: 'Kyrgyz' },
  { code: 'lo', name: 'ລາວ', en: 'Lao' },
  { code: 'la', name: 'Latina', en: 'Latin' },
  { code: 'lv', name: 'Latviešu', en: 'Latvian' },
  { code: 'lt', name: 'Lietuvių', en: 'Lithuanian' },
  { code: 'lb', name: 'Lëtzebuergesch', en: 'Luxembourgish' },
  { code: 'mk', name: 'Македонски', en: 'Macedonian' },
  { code: 'mg', name: 'Malagasy', en: 'Malagasy' },
  { code: 'ms', name: 'Bahasa Melayu', en: 'Malay' },
  { code: 'ml', name: 'മലയാളം', en: 'Malayalam' },
  { code: 'mt', name: 'Malti', en: 'Maltese' },
  { code: 'mi', name: 'Māori', en: 'Maori' },
  { code: 'mr', name: 'मराठी', en: 'Marathi' },
  { code: 'mn', name: 'Монгол', en: 'Mongolian' },
  { code: 'my', name: 'မြန်မာ', en: 'Myanmar (Burmese)' },
  { code: 'ne', name: 'नेपाली', en: 'Nepali' },
  { code: 'no', name: 'Norsk', en: 'Norwegian' },
  { code: 'ny', name: 'Chichewa', en: 'Nyanja (Chichewa)' },
  { code: 'or', name: 'ଓଡ଼ିଆ', en: 'Odia (Oriya)' },
  { code: 'ps', name: 'پښتو', en: 'Pashto' },
  { code: 'fa', name: 'فارسی', en: 'Persian' },
  { code: 'pl', name: 'Polski', en: 'Polish' },
  { code: 'pt', name: 'Português', en: 'Portuguese' },
  { code: 'pa', name: 'ਪੰਜਾਬੀ', en: 'Punjabi' },
  { code: 'ro', name: 'Română', en: 'Romanian' },
  { code: 'ru', name: 'Русский', en: 'Russian' },
  { code: 'sm', name: 'Gagana Samoa', en: 'Samoan' },
  { code: 'gd', name: 'Gàidhlig', en: 'Scots Gaelic' },
  { code: 'sr', name: 'Српски', en: 'Serbian' },
  { code: 'st', name: 'Sesotho', en: 'Sesotho' },
  { code: 'sn', name: 'ChiShona', en: 'Shona' },
  { code: 'sd', name: 'سنڌي', en: 'Sindhi' },
  { code: 'si', name: 'සිංහල', en: 'Sinhala' },
  { code: 'sk', name: 'Slovenčina', en: 'Slovak' },
  { code: 'sl', name: 'Slovenščina', en: 'Slovenian' },
  { code: 'so', name: 'Soomaali', en: 'Somali' },
  { code: 'es', name: 'Español', en: 'Spanish' },
  { code: 'su', name: 'Basa Sunda', en: 'Sundanese' },
  { code: 'sw', name: 'Kiswahili', en: 'Swahili' },
  { code: 'sv', name: 'Svenska', en: 'Swedish' },
  { code: 'tl', name: 'Tagalog', en: 'Tagalog (Filipino)' },
  { code: 'tg', name: 'Тоҷикӣ', en: 'Tajik' },
  { code: 'ta', name: 'தமிழ்', en: 'Tamil' },
  { code: 'tt', name: 'Татарча', en: 'Tatar' },
  { code: 'te', name: 'తెలుగు', en: 'Telugu' },
  { code: 'th', name: 'ไทย', en: 'Thai' },
  { code: 'tr', name: 'Türkçe', en: 'Turkish' },
  { code: 'tk', name: 'Türkmen', en: 'Turkmen' },
  { code: 'uk', name: 'Українська', en: 'Ukrainian' },
  { code: 'ur', name: 'اردو', en: 'Urdu' },
  { code: 'ug', name: 'Uyghur', en: 'Uyghur' },
  { code: 'uz', name: 'Oʻzbek', en: 'Uzbek' },
  { code: 'vi', name: 'Tiếng Việt', en: 'Vietnamese' },
  { code: 'cy', name: 'Cymraeg', en: 'Welsh' },
  { code: 'xh', name: 'isiXhosa', en: 'Xhosa' },
  { code: 'yi', name: 'ייִדיש', en: 'Yiddish' },
  { code: 'yo', name: 'Yorùbá', en: 'Yoruba' },
  { code: 'zu', name: 'isiZulu', en: 'Zulu' },
];

const BY_CODE = Object.fromEntries(VIBEVOX_LANGUAGES.map((l) => [l.code, l]));

/** Имя для отображения в кнопке-пикере (нативное). */
export function vibevoxLangName(code) {
  return BY_CODE[code]?.name || (code || '').toUpperCase();
}

/** Английское имя — его шлём Gemini как target ("translate into English"). */
export function vibevoxLangEnglish(code) {
  return BY_CODE[code]?.en || code || 'English';
}

/** Фильтр для поиска по коду / нативному / английскому имени. */
export function vibevoxFilterLanguages(query) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return VIBEVOX_LANGUAGES;
  return VIBEVOX_LANGUAGES.filter(
    (l) =>
      l.code.includes(q) ||
      l.name.toLowerCase().includes(q) ||
      l.en.toLowerCase().includes(q)
  );
}
